<template>
    <MainContainer>
        <section class="mitgliedsbeitraege-druck-filter">
            <h3>Auswahl Beitragsrechnungen</h3>
            <b-form @submit="submit" @reset="reset">
                <b-form-group
                    label-cols-sm="2"
                    label-for="inputYear"
                    :label-size="size"
                >
                    <template v-slot:label>Jahr auswählen:</template>
                    <template v-if="years.busy">
                        <ContentLoadingBlock />
                    </template>
                    <template v-else>
                        <b-select
                            id="inputYear"
                            :options="years.options"
                            v-model="filter.year"
                            :size="size"
                        />
                    </template>
                </b-form-group>
                <b-form-group
                    label-cols-sm="2"
                    label="Sortierung:"
                    label-for="inputOrderBy"
                    :label-size="size"
                >
                    <b-select
                        id="inputOrderBy"
                        v-model="filter.orderby"
                        :options="orderBy"
                        :size="size"
                    />
                </b-form-group>
                <b-form-group
                    label-cols-sm="2"
                    label="Mitgliederauswahl:"
                    label-for="inputMitglieder"
                    :label-size="size"
                >
                    <CheckboxSelect
                        id="inputMitglieder"
                        v-model="filter._mitglied_id"
                        :selectSize="5"
                        :sortActive="true"
                        :isBusy="mitglieder.busy"
                        :options="mitglieder.options"
                        :size="size"
                    />
                </b-form-group>
                <b-form-group>
                    <b-button

                        variant="primary"
                        @click="submit"
                        :size="size"
                    >
                        Anzeigen
                    </b-button
                    >
                    <b-button
                        type="reset"
                        variant="outline-danger"
                        :size="size"
                        class="ml-1"
                    >
                        Felder zurücksetzen
                    </b-button>
                </b-form-group>
            </b-form>
        </section>
        <PopUpChecker />
        <div
            class="loading-modal container-fluid d-flex justify-content-center align-items-center p-3"
            v-if="busy"
        >
            <div class="d-flex flex-column align-items-center">
                <h6 class="mb-3">Daten werden geladen. Bitte haben Sie etwas Geduld!</h6>
                <b-spinner style="width: 3rem; height: 3rem;" label="Large Spinner"></b-spinner>
            </div>
        </div>
    </MainContainer>
</template>

<script>
import MainContainer from "@/components/MainContainer/MainContainer";
import Size from "@/mixins/Size/Size";
import {ApiFactory} from "@/api/ApiFactory";
import CheckboxSelect from "@/components/CheckboxSelect/CheckboxSelect";
import ContentLoadingBlock from "@/components/ContentLoadingBlock/ContentLoadingBlock";
import {BlobUtil} from "@/utils/BlobUtil";
import Toaster from "@/mixins/Toaster/Toaster";
import CommonView from "@/mixins/CommonView/CommonView";
import PopUpChecker from "@/components/PopUpChecker/PopUpChecker.vue";

const MitgliedsbeitaegeApi = ApiFactory.get("fiBuMitgliedsbeitraegeApi");
const MitgliederApi = ApiFactory.get("mitglieder");

export default {
    name: "FiBuMitgliedsbeitraegeDruck",
    mixins: [Size, Toaster],
    components: {
        PopUpChecker,
        MainContainer,
        CheckboxSelect,
        ContentLoadingBlock
    },
    data() {
      return {
          filter: {
              year: null,
              // _from_date: null,
              // _to_date: null,
              orderby: 'name',
              _mitglied_id: []
          },
          orderBy: [
              {
                  value: "status",
                  text: "Status"
              },
              {
                  value: "name",
                  text: "Name"
              },
              {
                  value: "plz",
                  text: "PLZ"
              }
          ],
          mitglieder: {
              busy: false,
              items: [],
              options: []
          },
          years: {
              busy: false,
              items: [],
              options: []
          },
          busy: false,
      }
    },
    created() {
        this.fetchMitglieder();
        this.fetchYears();
    },
    methods: {
        async fetchMitglieder() {
            this.mitglieder.busy = true;

            const response = await MitgliederApi.get({
                fields: ["id", "vorname", "name"],
                order: "name",
                sort: "asc",
                limit: -1
            });

            if (response.ok) {
                const items = response.json.collection;
                this.mitglieder.items = items;
                this.mitglieder.options = items.map(item => {
                    return {
                        text: `${item.name}, ${item.vorname} (${item.id})`,
                        value: item.id
                    };
                });
            }
            this.mitglieder.busy = false;
        },
        async fetchYears() {
            this.years.busy = true;

            const response = await MitgliedsbeitaegeApi.getAllYearsRelatedToMitgliederbeitraege();

            if(response.ok) {
                const options = response.json.collection.map(item => {
                    return {
                        text: parseInt(item),
                        value: parseInt(item)
                    }
                });

                options.splice(0, 0, {text: 'Datum auswählen', value: null});

                this.years.options = options;
            }

            this.years.busy = false;
        },
        async submit(evt) {
            evt.preventDefault();
            this.busy = true;

            const response = await MitgliedsbeitaegeApi.printSelectedMitgliedsbeitraege({
                filter: this.filter
            });

            if(response.ok) {
                const hasPopUpBlocker = BlobUtil.openBlob(response.blob);
                if (hasPopUpBlocker) {
                    this.$bvModal.show('pop-up-checker');
                }
            } else {
                this.makeToast(
                    "Fehler",
                    "Es konnten keine Beitragsrechnungen zu den ausgewählten Mitgliedern gefunden werden!",
                    "danger"
                );
                this.reset();
            }

            this.busy = false;
        },
        processFilter() {
            var filter = Object.assign({}, this.filter);
            var processedFilter = {};
            for (const prop in filter) {
                if (filter[prop] !== null) {
                    processedFilter[prop] = filter[prop];
                }
            }
            return processedFilter;
        },
        reset(evt) {
            evt.preventDefault();

            this.filter = {
                year: null,
                orderby: 'name',
                mitglied: null
            }
        }
    }
}
</script>

<style scoped>

</style>